import React from 'react';
import { Link } from 'react-router-dom';
import ProtectedEmail from '../components/ProtectedEmail';
import logo512 from '../assets/images/logo512.png';

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2rem' }}>
            <img 
              src={logo512} 
              alt="Đức Phát Đạt Logo" 
              style={{ 
                height: '100px', 
                width: 'auto', 
                marginRight: '25px'
              }} 
            />
            <div style={{ textAlign: 'left' }}>
              <h1 style={{ margin: 0 }}>Đức Phát Đạt</h1>
              <p style={{ margin: '0.5rem 0' }}>Chuyên phân phối gỗ nguyên liệu hàng đầu tại Việt Nam</p>
            </div>
          </div>
          <p>Hơn 15 năm kinh nghiệm trong lĩnh vực gỗ với tôn chỉ hoạt động đặt chữ "TÍN" lên hàng đầu</p>
          <div style={{ marginTop: '2rem' }}>
            <Link to="/services" className="btn btn-primary">
              Khám phá dịch vụ
            </Link>
            <Link to="/contact" className="btn btn-secondary" style={{ marginLeft: '1rem' }}>
              Liên hệ ngay
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Về Đức Phát Đạt</h2>
            <p>Một trong những chuyên gia phân phối gỗ nguyên liệu hàng đầu tại Việt Nam</p>
          </div>
          
          <div className="grid grid-2">
            <div className="card">
              <h3>Kinh nghiệm 15+ năm</h3>
              <p>Thành lập từ năm 2009, chúng tôi đã xây dựng được uy tín và kinh nghiệm sâu rộng trong ngành gỗ Việt Nam.</p>
            </div>
            
            <div className="card">
              <h3>Chất lượng đảm bảo</h3>
              <p>Tất cả sản phẩm gỗ được khai thác hợp pháp, đảm bảo yếu tố bảo vệ môi trường và chất lượng cao.</p>
            </div>
            
            <div className="card">
              <h3>Đối tác tin cậy</h3>
              <p>Là đối tác thường xuyên của nhiều đơn vị sản xuất, xuất khẩu hàng nội – ngoại thất uy tín.</p>
            </div>
            
            <div className="card">
              <h3>Dịch vụ chuyên nghiệp</h3>
              <p>Cung cấp đầy đủ dịch vụ từ bán gỗ tròn, gỗ xây dựng đến cưa xẻ gia công và vận chuyển.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>Dịch vụ của chúng tôi</h2>
            <p>Cung cấp đầy đủ các dịch vụ về gỗ nguyên liệu</p>
          </div>
          
          <div className="grid grid-3">
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🪵</div>
              <h3>Gỗ tròn & Gỗ xây dựng</h3>
              <p>Chuyên môn bán gỗ tròn, gỗ xây dựng chất lượng cao với nhiều loại gỗ thông, gỗ coffa.</p>
              <Link to="/services" className="btn btn-primary">
                Xem chi tiết
              </Link>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🔨</div>
              <h3>Cưa xẻ gia công</h3>
              <p>Nhận cưa xẻ gỗ gia công theo quy cách với độ chính xác cao và kinh nghiệm hơn 15 năm.</p>
              <Link to="/services" className="btn btn-primary">
                Xem chi tiết
              </Link>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '3rem', color: 'var(--accent-color)', marginBottom: '1rem' }}>🚛</div>
              <h3>Dịch vụ xe cẩu</h3>
              <p>Dịch vụ cẩu gỗ, thiết bị nặng với tài xế 10 năm kinh nghiệm trong ngành.</p>
              <Link to="/services" className="btn btn-primary">
                Xem chi tiết
              </Link>
            </div>
          </div>
        </div>
      </section>


      {/* Contact CTA */}
      <section className="section bg-light">
        <div className="container text-center">
          <h2>Liên hệ ngay để được tư vấn</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
            Hotline: <strong>0915 444 447</strong> (anh Kiên) hoặc <strong>0906 838 171</strong> (cô Nhung)
          </p>
          <p style={{ marginBottom: '2rem' }}>
            📧 Email: <ProtectedEmail email="ducphatdatco@gmail.com" />
          </p>
          <Link to="/contact" className="btn btn-primary">
            Liên hệ ngay
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
